import request from "@/api";

export function listClub(data) {
    return request({
        url: '/api/club/getClubList',
        method: 'get',
        params: data
    })
}
export function saveClub(data) {
    return request({
        url: '/api/club/saveClub',
        method: 'post',
        data: data
    })
}

export function getClubInfo(data) {
    return request({
        url: '/api/club/getClubInfo',
        method: 'get',
        params: data
    })
}

export function deleteClub(data) {
    return request({
        url: '/api/club/deleteClub',
        method: 'post',
        data: data
    })
}